<!--  -->
<template>
    <div class="header">
        <div class="menu flex-align-between">
            <el-dropdown v-for="(item, index) in meunList" :key="index" @command="handleCommand" :disabled="item.disabled">
                <div class="meun_item flex-align-center" :class="{ 'menu_item_active': menuId == item.id }"
                    @click="selectMenu(item)">
                    {{ item.name }}
                </div>
                <el-dropdown-menu slot="dropdown" style="width:230px;padding:0;border:none">
                    <el-dropdown-item :disabled="item.disabled" v-for="(items, index) in item.childList" :key="index"
                        :command="items">
                        {{ items.name }}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <div class="userInfo flex-align-center" v-if="userName">
                <el-dropdown trigger="click" class="csp" style="align-items: center;">
                    <img src="../../../assets/images/avatar.png" />
                    <span style="margin-left: 10px;">{{ userName }}</span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="goCenter">个人中心</el-dropdown-item>
                        <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="login flex-align-center" @click="login" v-else>登录</div>
        </div>
        <Login3 v-if="showLogin" :logoType="logoType" @getUserinfo="getUserinfo" @hideLogin="hideLogin"></Login3>
    </div>
</template>
<script>
import { EventBus } from '../../eventBus';
import {
    mapState
} from 'vuex'
export default {
    data() {
        return {
            meunList: [{
                id: 1,
                name: '首页',
                href: '/home',
                disabled: true
            },
            {
                id: 2,
                name: '通知公告',
                href: '/home/news?clazz=1&type=1',
                disabled: true
            },
            {
                id: 3,
                name: '工作动态',
                href: '/home/news?clazz=1&type=2',
                disabled: true
            },
            {
                id: 4,
                name: '三一三同',
                childList: [{
                    id: 5,
                    name: `同步课堂`,
                    href: '/home/school'
                },
                {
                    id: 6,
                    name: '同步教研',
                    href: '/home/syncJY'
                },
                {
                    id: 7,
                    name: '同步成长',
                    href: '/home/syncCZ'
                },
                {
                    id: 8,
                    name: '一校',
                    href: '/home/school2'
                },
                {
                    id: 9,
                    name: '一杯',
                    href: '/home/cup2'
                },
                {
                    id: 10,
                    name: '一论坛',
                    href: '/home/forum'
                },
                ],
                disabled: false
            },
            {
                id: 11,
                name: '协作项目',
                href: '',
                childList: [{
                    id: 14,
                    name: '教师队伍能力提升',
                    href: '/home/power'
                },
                {
                    id: 15,
                    name: '校(园)长工作室'
                },
                {
                    id: 16,
                    name: '组团式教育帮扶',
                    href: '/home/help'
                },
                {
                    id: 17,
                    name: '职业教育创新发展'
                },
                {
                    id: 18,
                    name: '高校合作交流'
                },
                {
                    id: 19,
                    name: '结对旗县教育协作高质量发展'
                },
                {
                    id: 20,
                    name: '开展青少年学生研学活动',
                    href: '/home/xzProject'
                },
                {
                    id: 21,
                    name: '社会力量参与教育协作机制'
                },
                ],
                disabled: false
            },
            {
                id: 12,
                name: '教改实践',
                href: '/home/shijian',
                disabled: true
            },
            {
                id: 13,
                name: '协作管理空间',
                disabled: true
            },
            {
                id: 14,
                name: '空中课堂',
                disabled: true
            },
            {
                id: 22,
                name: '智慧研修',
                disabled: true,
                href: '/upDateInfo'
            }
            ],
            menuId: 1,
            childList: [{
                id: 5,
                name: '同步课堂',
                href: '/home/school'
            },
            {
                id: 6,
                name: '同步教研',
                href: '/home/syncJY'
            },
            {
                id: 7,
                name: '同步成长',
                href: '/home/syncCZ'
            },
            {
                id: 8,
                name: '一校',
                href: '/home/school2'
            },
            {
                id: 9,
                name: '一杯',
                href: '/home/cup2'
            },
            {
                id: 10,
                name: '一论坛',
                href: '/home/forum'
            },
            ],
            childList2: [{
                id: 14,
                name: '教师队伍能力提升2',
                href: '/home/power'
            },
            {
                id: 15,
                name: '校(园)长工作室'
            },
            {
                id: 16,
                name: '组团式教育帮扶'
            },
            {
                id: 17,
                name: '职业教育创新发展'
            },
            {
                id: 18,
                name: '高校合作交流'
            },
            {
                id: 19,
                name: '结对旗县教育协作高质量发展'
            },
            {
                id: 20,
                name: '开展青少年学生研学活动',
                href: '/home/xzProject'
            },
            {
                id: 21,
                name: '社会力量参与教育协作机制'
            },
            ],
            showChildList: false,
            showChildList2: false,
            showLogin: false,
            userName: '',
            logoType: '',
            isLogin: false
        }
    },
    methods: {
        login(type) {
            // window.open("https://jm.cnuen.net/login")
            this.logoType = '登录';
            this.showLogin = true;
            this.$store.commit('isDisplayLogin', true);
            if (type) {
                this.logoType = type;
            }
        },
        selectMenu(item) {
            console.log('item:',item)
            this.$store.commit('storageHeader', item.name)
            //如果下一次点击头部name[item.name]和上一次一样 不让执行[防止newbreadcrumb错乱]
            this.menuId = item.id;
            if (this.$store.state.basics.storageHeaderName == '空中课堂' || this.$store.state.basics.storageHeaderName == '智慧研修' || this.$store.state.basics.storageHeaderName == '协作管理空间') {
                // this.menuId = item.id;
                if (item.name == '空中课堂') {
                    this.logoType = '空中课堂';
                    if (this.$route.query.ticket) {
                        this.getBindInfo('空中课堂')
                    } else {
                        this.checkToken();
                    }
                } else if (item.name == '智慧研修') {
                    this.logoType = '智慧研修';
                    if (this.$route.query.ticket) {
                        this.getBindInfo('智慧研修')
                    } else {
                        this.checkToken();
                    }
                } 
                else if (item.name == '协作管理空间') {
                    this.logoType = '协作管理空间';
                    this.checkToken();
                }

            } else {
                // this.menuId = item.id;
                // if (item.name == '协作管理空间') {
                //     // window.open("https://dctest.lezhireading.com/#/jmcountry");
                //     window.open("https://dctest.lezhireading.com/#/country");
                // } else
                if (item.name == '教改实践') {
                    this.$message({
                        message: '暂未开放',
                        type: 'error'
                    });
                } else {
                    let data = {
                        name: item.name,
                        path: item.href,
                    }
                    this.$store.commit('replace', data)
                    this.$router.push({
                        path: item.href,

                    })
                }
            }
        },
        selectChildMenu(item) {
            console.log(item)
            this.$router.push({
                path: item.href
            })
        },
        onMouseenter(id) {
            this.menuId = id;
        },
        onMouseleave() {
            // this.menuId = -1
        },
        handleCommand(command) {

            let list = ['教师队伍能力提升', '校(园)长工作室', '职业教育创新发展', '高校合作交流', '结对旗县教育协作高质量发展', '社会力量参与教育协作机制'];
            console.log('command:', command);
            if (list.indexOf(command.name) >= 0) {
                this.$message({
                    message: '暂未开放',
                    type: 'error'
                });
                return
            }
            this.$router.push({
                path: command.href
            })
            // //判断三一三同
            // if ([5,6].indexOf(command.name) >= 0) {
            //     console.log('111111111111+++++++',command);
            // }
        },
        // 教育云-判断是否绑定、判断是否是虚拟账号过来
        getBindInfo(toPath) {
            if (this.$route.query.ticket) {
                let data = {
                    ticket: this.$route.query.ticket
                }
                if (this.isLogin) {
                    this.checkToken()
                } else {
                    Api.Login.getBindInfo(data)
                        .then(res => {
                            console.log('判断教育云是否绑定:', res);
                            if (res.code == 500) {
                                this.$message.error(res.msg);
                            }
                            if (res.data.bind) {
                                // 绑定过直接走登录
                                console.log('绑定过直接登录');
                                this.isLogin = true
                                sessionStorage.setItem('token', res.data.access_token);
                                this.getUserinfo();
                            } else {
                                // 没绑定过，去完善资料
                                console.log('没绑定过需完善资料');
                                this.isLogin = false
                                this.$router.push({
                                    path: '/upDateInfo',
                                    query: {
                                        tempToken: res.data.temp_token,
                                        toPath
                                    }
                                })
                            }
                        })
                        .catch(err => {
                            console.log('判断教育云是否绑定err:', err)
                        })
                }

            } else if (this.$route.query.isVirtual) {
                this.logoType = this.$route.query.logoType;
                this.showLogin = true;
                this.$store.commit('isDisplayLogin', true);
            } else {
                this.getUserinfo()
            }
        },
        // 获取用户信息
        async getUserinfo() {
            let resData = await Api.Login.userInfo();
            console.log('获取个人信息123', resData);
            if (JSON.stringify(resData.data) == '{}') {
                this.$message.error('获取个人信息失败，请联系管理员');
                return;
            }
            if (resData.code == 401) {
                // this.$message.error(resData.msg);
                return
            }
            this.userName = resData.data.name;
        },
        // 获取跳转空中课堂code
        async getUrlCode(phone, userId) {
            let data = {
                phone,
                userId,
                projectId: 280,
                userRole: 100
            }
            let resData = await Api.Login.getCode(data);
            console.log('获取跳转空中课堂code:', resData);
            if (resData.code == 200) {
                window.open(`https://basic.beijing.smartedu.cn/autologin?code=${resData.data}`);
                // window.open(`https://basic.beijing.smartedu.cn/index?code=${resData.data}`);
                // window.open(`https://kzkt.haigrid.com/autologin?code=${resData.data}`);
            } else {
                this.$message({
                    message: '获取code失败,请联系管理员',
                    type: 'error'
                });
            }
        },
        // 判断token是否有效
        async checkToken() {
            let resData = await Api.Login.userInfo();
            console.log('获取个人信息2', resData);
            if (resData.code == 401) {
                this.showLogin = true;
                this.$store.commit('isDisplayLogin', true);
                return
            } else {
                this.userName = resData.data.name;
                if (this.logoType == '空中课堂') {
                    // 跳转空中课堂
                    this.getUrlCode(resData.data.phone, resData.data.id)
                }else if(this.logoType == '协作管理空间'){
                    console.log('跳转大屏')
                    let access_token = sessionStorage.getItem('token');
                    // window.open(`https://dctest.lezhireading.com/#/leader_data?projectId=234&projectName=classin正式&token=${access_token}&roleId=124`)
                    window.open("https://dctest.lezhireading.com/#/country")
                }else {
                    // 跳转京蒙研修
                    let access_token = sessionStorage.getItem('token');
                    let member = sessionStorage.getItem('member')
                    window.open(`https://jm.cnuen.net/login?origin=cnueb&access_token=${access_token}&member=${member}`)
                }
            }
        },
        // 退出登录
        logout() {
            this.isLogin = false;
            this.userName = '';
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('member');
            this.$router.push('/home')
        },
        // 个人中心
        goCenter() {
            let access_token = sessionStorage.getItem('token');
            let member = sessionStorage.getItem('member')
            window.open(`https://jm.cnuen.net/login?origin=cnueb&access_token=${access_token}&member=${member}&path=my`);
        },
        // 隐藏login
        hideLogin() {
            console.log('隐藏登录弹窗')
            this.isLogin = false
        },
        // 监听路由
        watchRoute(){
            if(this.$route.name == 'newsList'){
                if(this.$route.query.type == 1){
                    this.menuId = 2
                }else if(this.$route.query.type == 2){
                    this.menuId = 3
                }
            }else if(this.$route.name == 'newsDetail'&&this.$route.query.type==1){
                this.menuId = 2
            }
        }
    },
    mounted() {
        this.watchRoute();
        this.getBindInfo();
        EventBus.$on('test', message => {
            console.log(message); // 输出：Hello from ComponentA
            this.getUserinfo()
        });
    },
};
</script>
<style lang='less' scoped>
@import url("./newHeader.less");
</style>